export default {
  sidebarOpen: true,
  notifications: {
    total: 4
  }
};
